import { isFunction, pick } from 'lodash';

export const renderChildren = (children, context) => {
  return isFunction(children) ? children(context) : children;
};

export const getPropsFromTypes = (
  props: any,
  propTypes: any,
  filterRegex?: any,
) => {
  // Just to be sure we include general props that every component accepts...
  const generalProps = ['style'];

  let propKeys = [...Object.keys(propTypes), ...generalProps];

  if (filterRegex instanceof RegExp) {
    const filterRegexProps = Object.keys(props).filter((key) =>
      filterRegex.test(key),
    );
    propKeys = [...propKeys, ...filterRegexProps];
  }

  return pick(props, propKeys);
};

export function watchForEffectInputs(props, watchKeys) {
  return (
    Object.entries(props)
      .filter(([key]) => watchKeys.includes(key))
      // eslint-disable-next-line @typescript-eslint/no-unused-vars,no-unused-vars
      .map(([_, value]) => value)
  );
}
